import { Component, OnInit, HostBinding } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { NavMenu } from '../nav-menu';
import { EventListenerService } from '../../../services/close-listenenr.service';
import { slideToRight } from '../../../shared/animations.collections';
import { CurrentUserModel } from '../../../models/account-ledger.model';
import { ShoppingCartService } from '../../../services/shopping-cart.service';
import { MyAccountService } from '../../../services/myAccount.service';
import { FeedbackInfo } from '../../../models/feedback-info.model';
import { CommonService } from '../../../services/common.service';
import { AuthService } from "../../../services/auth.service";

@Component({
    selector: 'app-feed-back',
    templateUrl: './feed-back.component.html',
    styleUrls: ['./feed-back.component.css'],
    providers: [MyAccountService],
    animations: [slideToRight()]
})

export class FeedBackComponent extends NavMenu implements OnInit {
    @HostBinding('@slideToRight') ani;

    title = "Send Feedback";
    currentUserModel: CurrentUserModel;
    feedbackForm: FormGroup;
    sendComments:FeedbackInfo = <FeedbackInfo>{}; 
    showResult: boolean = false;
    disableButton: boolean = false;
    errorMsg: string;
    
    constructor(
        private shoppingCartService: ShoppingCartService,
        private feedbackService: MyAccountService,
        private fb: FormBuilder, 
        private commonService: CommonService,
        closeLitsener: EventListenerService,
    private authService: AuthService

    ) {
        super(closeLitsener);
    }
    

    ngOnInit(): void {
        this.feedbackForm = this.fb.group({
            firstName:['', Validators.required],
            lastName: ['', Validators.required],
            email: ['', [Validators.required, Validators.email]],
            phone: [''],
            comments: ['', Validators.required],
        });

        this.authService.getLoginInfo().subscribe((res: CurrentUserModel) => {
            this.currentUserModel = res;
            this.feedbackForm.patchValue({
                firstName: this.currentUserModel.firstName,
                lastName: this.currentUserModel.lastName,
                email: this.currentUserModel.email
            });
        },
            (error: any) => {
                console.info(error);
            });

    }

    isFieldValid(field: string): boolean {
        return !this.feedbackForm.get(field).valid && this.feedbackForm.get(field).touched;
    }

    displayFieldCss(field: string) {
        return {
            'error-wrapper': this.isFieldValid(field),
        };
    }

    onSubmit(): void {  
        if (this.feedbackForm.valid) {
            this.sendComments.FirstName = this.feedbackForm.get('firstName').value.toString();
            this.sendComments.LastName = this.feedbackForm.get('lastName').value.toString();
            this.sendComments.Email = this.feedbackForm.get('email').value.toString();
            this.sendComments.Phone = this.feedbackForm.get('phone').value.toString();
            this.sendComments.Comments = this.feedbackForm.get('comments').value.toString();

            //sending data to the backend
            // this.feedbackService.passFeedbackInfo(this.sendComments).subscribe((data: any) => {
            //     console.log(data);
            //     this.disableButton = true;
            //     this.errorMsg = data.responseMessage;
            //     this.commonService.showResult("#send-feedback-button", this.errorMsg, "left", 3000);
                
            //     setTimeout(()=>{ 
            //         this.showResult = false;
            //         if(this.feedbackForm.get('comments').valid){
            //             this.feedbackForm.get("comments").reset();
            //             this.disableButton = false;
            //         }
            //     }, 3000)
            // }); 
        }else{
            this.validateAllFormFields(this.feedbackForm);
        }
    }

    validateAllFormFields(formGroup: FormGroup): void {
        Object.keys(formGroup.controls).forEach(field => {
            const control = formGroup.get(field);
            if (control instanceof FormControl) {
            control.markAsTouched({ onlySelf: true });
            } else if (control instanceof FormGroup) {
            this.validateAllFormFields(control);
            }
        });
    }

}


